import React, {Component} from 'react';
import './App.css';
import Footer from './components/Footer';
import Home from './scenes/Home'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import ReactGA from 'react-ga';

class App extends Component {
    constructor(props) {
        super(props);
        ReactGA.initialize('UA-117509383-2')
    }

    componentWillMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
            <div>
                <Home />
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js